// extracted by mini-css-extract-plugin
export var fullWidthButton = "_nx-0";